package one.healthium.reminders.data

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.reminders.data.dto.RemindersDto
import one.healthium.reminders.data.mapper.ReminderMapper
import one.healthium.reminders.domain.ReminderModel
import one.healthium.reminders.domain.RemindersRepository
import one.healthium.locale.LocaleProvider
import one.primehealth.app.BaseAppResourceProvider

internal class AppRemindersRepository(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider,
    private val reminderMapper: ReminderMapper,
    private val localeProvider: LocaleProvider,
) : RemindersRepository {
    override suspend fun getReminders(): List<ReminderModel> {
        return withContext(Dispatchers.IO) {
            val locale = localeProvider.getLocale()
            val bytes = appResourceProvider.readBytes("files/reminders/$locale/reminders_v1.json")
            val dto = json.decodeFromString<RemindersDto>(bytes.decodeToString())
            reminderMapper.dtoToModel(dto)
        }
    }
}